import {useCallback, useEffect, useRef, useState} from "react";
import DragDropInput from "./DragDropInput";
import DraggableScrollDiv from "../draggableScroll/DraggableScrollDiv";
import {useIsVisible} from "../../hooks";

export function DragDropForm({
                                 fileTypes, defaultValue, value, parentRef, width = "fit", height = "300px",
                                 onChange = () => {}, ...other}) {
    const [files, setFiles] = useState({});
    const stateRef = useRef({});
    const [fitWidth, setFitWidth] = useState("100%");
    const isVisible = useIsVisible(parentRef);
    // Keep an updated reference to state for callback use
    stateRef.current = files;

    useEffect(()=>{
        if(parentRef?.current){
            window.addEventListener("resize", ()=>{
                setFitWidth(parentRef.current?.getBoundingClientRect().width);
            })
            setFitWidth(parentRef.current?.getBoundingClientRect().width);
        }
    }, [parentRef])

    useEffect(()=>{
        setFitWidth(parentRef?.current?.getBoundingClientRect().width);
    }, [isVisible])

    useEffect(() => {
        if (value) {
            setFiles(value);
        } else if (defaultValue) {
            setFiles(defaultValue);
        }
    }, [defaultValue, value]);

    function onChangeCallback(file, name) {
        let copy = {...stateRef.current};
        copy[name] = file;
        if (value) {
            onChange(copy, name);
        } else {
            setFiles(copy);
        }
    }

    const onDeleteCallback = useCallback((name) => {
        let copy = {...stateRef.current};
        delete copy[name];
        if (value) {
            onChange(copy, name);
        } else {
            setFiles(copy);
        }
    }, [files])

    let newKeys = Object.keys(files);
    newKeys.push("file"+newKeys.length)
    return <div {...other}>
            {
                newKeys.map((key) => {
                    return <DragDropInput key={key} fileTypes={fileTypes} defaultValue={files[key]} name={key}
                                          onChangeCallback={onChangeCallback} onDeleteCallback={onDeleteCallback}
                                          style={{width: width==="fit"? fitWidth :width, height: height}}/>
                })
            }


        </div>
}

export function ScrollableDragDropForm({fileTypes}){
    const draggableDivRef = useRef();

    return <DraggableScrollDiv ref={draggableDivRef}>
        <DragDropForm className={"horizontal"} fileTypes ={fileTypes} parentRef={draggableDivRef} width={"fit"}/>
    </DraggableScrollDiv>;
}